import { topBarBackgroundColor } from "@faire/retailer-visitor-shared/components/Header/Colors";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";
export var TopBar = styled.div.withConfig({
    componentId: "sc-ea995fdd-0"
})([
    "display:flex;align-self:stretch;background:",
    ";flex-direction:column;align-items:flex-start;justify-content:flex-start;padding:16px 20px 8px 20px;"
], topBarBackgroundColor);
export var MenuContainer = styled.div.withConfig({
    componentId: "sc-ea995fdd-1"
})([
    "position:fixed;top:60px;height:calc(100% - 60px);left:0;z-index:1;width:100vw;background:white;display:flex;flex-direction:column;transition:opacity 0.05s linear;",
    "{top:50px;height:calc(100% - 50px);&.with-promo-banner{top:",
    "px;height:calc(100% - ",
    "px);}}",
    "{&.with-promo-banner{top:95px;height:calc(100% - 95px);}}"
], responsiveMediaQueries.mobile, function(props) {
    var _props_$height;
    return ((_props_$height = props.$height) !== null && _props_$height !== void 0 ? _props_$height : 0) + 50;
}, function(props) {
    var _props_$height;
    return ((_props_$height = props.$height) !== null && _props_$height !== void 0 ? _props_$height : 0) + 50;
}, responsiveMediaQueries.tablet);
